import React, { useState, useRef, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Globe, ChevronDown, Check } from 'lucide-react';
import { LANGUAGES } from '../i18n/translations';

export const LanguageSwitcher = () => {
  const { i18n, t } = useTranslation();
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const onClick = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener('mousedown', onClick);
    return () => document.removeEventListener('mousedown', onClick);
  }, []);

  const currentLang = LANGUAGES.find(l => l.code === i18n.language) || LANGUAGES[0];

  return (
    <div className="relative" ref={ref}>
      <button
        onClick={() => setOpen(v => !v)}
        className="flex items-center gap-2 px-5 py-2 rounded-full border border-gray-200 bg-white/70 hover:bg-white text-sm font-medium text-gray-700 transition-all shadow-sm"
        data-testid="lang-switcher-btn"
        aria-label="Language"
      >
        <Globe className="w-4 h-4 text-emerald-600" />
        <span>{currentLang.label}</span>
        <ChevronDown className={`w-3.5 h-3.5 transition-transform ${open ? 'rotate-180' : ''}`} />
      </button>

      {open && (
        <div
          className="absolute right-0 mt-2 w-72 bg-white rounded-2xl shadow-2xl border border-gray-100 overflow-hidden z-50"
          data-testid="lang-switcher-panel"
        >
          <div className="px-4 py-3 bg-gray-50 border-b text-xs uppercase tracking-wider font-semibold text-gray-500 text-center">
            {t('nav.language', 'Language')}
          </div>
          <div className="max-h-80 overflow-y-auto py-1">
            {LANGUAGES.map(l => (
              <button
                key={l.code}
                onClick={() => { i18n.changeLanguage(l.code); setOpen(false); }}
                className={`w-full flex items-center justify-between px-4 py-2.5 text-sm hover:bg-emerald-50 transition-colors ${l.code === i18n.language ? 'bg-emerald-50 text-emerald-700 font-medium' : 'text-gray-700'}`}
                data-testid={`lang-${l.code}`}
                dir={l.dir}
              >
                <span className="flex-1 text-left">{l.label}</span>
                <span className="text-xs text-gray-400 uppercase mx-2">{l.code}</span>
                {l.code === i18n.language && <Check className="w-4 h-4 text-emerald-600" />}
              </button>
            ))}
          </div>
          <div className="px-4 py-2.5 bg-gray-50 border-t text-[11px] text-gray-500 text-center">
            Prices shown in your local currency automatically
          </div>
        </div>
      )}
    </div>
  );
};

export default LanguageSwitcher;
